import { openBrowserPopup } from 'Helpers/browserPopup'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilCallback } from 'recoil'

import { Actions } from 'mailup-web-components'

import { TEMPLATE_TYPE_LOCAL } from 'Constants/index'
import {
  canCopyTemplateCallback,
  modalCopyCallback,
  modalDeleteCallback
} from '../recoil/callbacks/callbacks'

const Action = ({ actions, type, id }) => {
  const intl = useIntl()
  const history = useHistory()
  const modalCopy = useRecoilCallback(modalCopyCallback, [])
  const modalDelete = useRecoilCallback(modalDeleteCallback, [])
  const canCopyTemplate = useRecoilCallback(canCopyTemplateCallback, [])
  const createActions = useCallback(() => {
    const { canPreview, canEdit, canCopyToLists, canDelete, canCopy } = actions
    const menuActions = [
      ...(canPreview
        ? [
            {
              label: intl.formatMessage({
                id: 'Load.Bee.TemplatesPreviewLabel'
              }),
              onClick: () => {
                type === TEMPLATE_TYPE_LOCAL
                  ? openBrowserPopup(`bee/Local/preview/${id}`)
                  : openBrowserPopup(`bee/Centralized/preview/${id}`)
              },
              'data-mu-test': 'action-preview'
            }
          ]
        : []),
      ...(canEdit
        ? [
            {
              label: intl.formatMessage({
                id: 'Load.Bee.TemplatesEditLabel'
              }),
              onClick: () => {
                history.push(`/templates/bee/edit/${id}`)
              },
              'data-mu-test': 'action-edit'
            }
          ]
        : []),
      ...(canCopyToLists
        ? [
            {
              label: intl.formatMessage({
                id: 'Load.Bee.TemplatesCopyToListsLabel'
              }),
              onClick: () => modalCopy(id),
              'data-mu-test': 'action-copy'
            }
          ]
        : []),
      ...(canDelete
        ? [
            {
              label: intl.formatMessage({
                id: 'Load.Bee.TemplatesDeleteLabel'
              }),
              onClick: () => modalDelete(id),
              'data-mu-test': 'action-delete'
            }
          ]
        : []),
      ...(canCopy
        ? [
            {
              label: intl.formatMessage({
                id: 'Load.MailupCommon.CreateCopy'
              }),
              onClick: async () => {
                const checkCanCopy = await canCopyTemplate()
                if (checkCanCopy) {
                  history.push(`/templates/bee/copy/${id}`)
                }
              },
              'data-mu-test': 'action-create-copy'
            }
          ]
        : [])
    ]

    return menuActions
  }, [])

  return <Actions items={createActions()} />
}

Action.propTypes = {
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  actions: PropTypes.array.isRequired
}

const propsAreEqual = (prev, next) => {
  return true
}
export const ActionMemoized = React.memo(Action, propsAreEqual)
